
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'

export default {
    components: {
        TitleBox
    },
    data() {
        return {
            qrCodeLoading: true,
            certifyUrl: null,
            certifyId: null,
            // 轮询循环
            realTime: null,
            refreshTime: false,

            resultIconUrl: {
                false: 'https://oss.pzds.com/imgv2/auth-fail.png',
                true: 'https://oss.pzds.com/imgv2/auth-success.png'
            },
            result: null,
            failText: '可能失败原因：身份信息与人脸不匹配，如都没问题请重试',
            metaInfo: undefined
        }
    },
    methods: {
        async doPageTracking() {
            const data = {
                action: {
                    pageEnName: 'certification_face',
                    pageZhName: '实名人脸认证'
                }
            }
            const res = await this.$api.pageTracking(data)
            console.log(res)
        },
        // 获取im
        async getAuthService() {
            const res = await this.$api.getAuthService()
            if (!res.success) return this.$message.warning(res.info)
            this.imId = res.data && res.data.username + ''
        },

        // 获取人脸url
        async getQRConfig() {
            const metaInfo = window.getMetaInfo()
            const returnUrl = process.env.ENV_AUTH_RETRUN_URL
            const data = {
                action: {
                    metaInfo: JSON.stringify(metaInfo),
                    returnUrl: returnUrl
                }
            }
            const res = await this.$api.getFaceAuth(data)
            if (!res.success) return this.$message.error(res.info)
            this.certifyUrl = res.data.certUrl
            this.certifyId = res.data.certifyId
            this.qrCodeLoading = false
            this.startRepeat()
        },
        // 刷新二维码
        refreshQr() {
            if (!this.refreshTime) {
                this.getQRConfig()
                this.refreshTime = true
                setTimeout(() => {
                    this.refreshTime = false
                }, 5000)
            } else {
                this.$message.warning('请勿频繁刷新，稍后再试')
            }
        },

        // 开始轮询
        startRepeat() {
            this.realTime = setInterval(() => {
                this.checkFaceAuthResult()
            }, 10000)

            // 10分钟？没动就不调用接口,关闭弹窗
            setTimeout(() => {
                clearInterval(this.realTime)
                this.result = false
            }, 600000)
        },
        // 获取轮询结果
        async checkFaceAuthResult() {
            const data = {
                action: {
                    certifyId: this.certifyId
                }
            }
            const res = await this.$api.checkFaceAuth(data)
            if (res.success) {
                let data = res.data
                if (data.passed === true) {
                    // 认证成功
                    clearInterval(this.realTime)
                    this.result = true
                }
                if (data.passed === false) {
                    console.log('认证失败')
                    // 认证失败
                    this.getAuthService()
                    clearInterval(this.realTime)
                    this.result = false
                }
                // 否则继续轮询
            } else {
                console.log('查询失败')
                clearInterval(this.realTime)
                this.$message.error(res.info)
            }
        },
        // 拉IM
        getIM() {
            if (!this.imId) return this.$message.warning('暂无客服值班')
            this.$store.dispatch('ry/join', { targetId: this.imId, conversationType: 1 })
            this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
            this.$store.commit('ry/SET_ORDER_FLOW', [])
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo'
        })
    },
    mounted() {
        this.doPageTracking()
        this.getQRConfig()
    },
    // 销毁
    destroyed() {
        clearInterval(this.realTime)
    }
}
